(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function track(event, data) {
    if (typeof window.srTrack !== 'function') return;
    window.srTrack(event, Object.assign(baseContext(), data || {}));
  }

  function baseContext() {
    var ctx = window.srContext || {};
    return {
      component: 'site',
      page_path: window.location.pathname,
      page_type: ctx.page_type || '',
      template: ctx.template || '',
      product_handle: ctx.product_handle || '',
      product_title: ctx.product_title || '',
      product_type: ctx.product_type || '',
      device_category: inferDeviceCategory(ctx),
      brand: inferBrand(ctx),
      model: inferModel(ctx),
      repair_type: inferRepairType(ctx.product_title || document.title || window.location.pathname)
    };
  }

  function inferDeviceCategory(ctx) {
    var text = [
      ctx.device_type,
      ctx.product_type,
      ctx.product_title,
      window.location.pathname
    ].join(' ').toLowerCase();

    if (text.indexOf('ipad') !== -1 || text.indexOf('tablet') !== -1) return 'ipad';
    if (text.indexOf('macbook') !== -1 || text.indexOf('laptop') !== -1) return 'macbook';
    if (text.indexOf('ipod') !== -1) return 'ipod';
    if (text.indexOf('iphone') !== -1 || text.indexOf('galaxy') !== -1 || text.indexOf('pixel') !== -1 || text.indexOf('phone') !== -1) return 'phone';
    return '';
  }

  function inferBrand(ctx) {
    var text = [
      ctx.device_type,
      ctx.product_title,
      window.location.pathname
    ].join(' ').toLowerCase();

    if (text.indexOf('iphone') !== -1 || text.indexOf('ipad') !== -1 || text.indexOf('ipod') !== -1 || text.indexOf('macbook') !== -1 || text.indexOf('apple') !== -1) return 'Apple';
    if (text.indexOf('samsung') !== -1 || text.indexOf('galaxy') !== -1) return 'Samsung';
    if (text.indexOf('google') !== -1 || text.indexOf('pixel') !== -1) return 'Google Pixel';
    if (text.indexOf('huawei') !== -1) return 'Huawei';
    if (text.indexOf('oneplus') !== -1) return 'OnePlus';
    if (text.indexOf('motorola') !== -1 || text.indexOf('moto') !== -1) return 'Motorola';
    if (text.indexOf('sony') !== -1 || text.indexOf('xperia') !== -1) return 'Sony';
    if (text.indexOf('xiaomi') !== -1 || text.indexOf('redmi') !== -1) return 'Xiaomi';
    return ctx.device_type || '';
  }

  function inferModel(ctx) {
    var title = String(ctx.product_title || document.title || '').replace(/\s*\|\s*Square Repair.*$/i, '');
    return title.replace(/\b(screen|battery|charging|charge|port|back|glass|camera|diagnosis|repair|replacement|service)\b.*$/i, '').trim();
  }

  function inferRepairType(text) {
    var value = String(text || '').toLowerCase();
    if (value.indexOf('water') !== -1 || value.indexOf('liquid') !== -1) return 'water-damage-diagnosis';
    if (value.indexOf('diagnosis') !== -1 || value.indexOf('diagnostic') !== -1) return 'diagnosis';
    if (value.indexOf('screen') !== -1 || value.indexOf('lcd') !== -1 || value.indexOf('display') !== -1) return 'screen-repair';
    if (value.indexOf('battery') !== -1) return 'battery-replacement';
    if (value.indexOf('charging') !== -1 || value.indexOf('charge port') !== -1 || value.indexOf('usb') !== -1) return 'charging-port-repair';
    if (value.indexOf('back glass') !== -1 || value.indexOf('rear glass') !== -1 || value.indexOf('back cover') !== -1) return 'back-glass-repair';
    if (value.indexOf('camera') !== -1) return 'camera-repair';
    if (value.indexOf('speaker') !== -1 || value.indexOf('microphone') !== -1 || value.indexOf('audio') !== -1) return 'audio-repair';
    if (value.indexOf('button') !== -1) return 'button-repair';
    return '';
  }

  function closestLink(target) {
    return target && target.closest ? target.closest('a[href]') : null;
  }

  function linkText(link) {
    return String(link.textContent || link.getAttribute('aria-label') || '').trim().slice(0, 120);
  }

  function bookingType(link) {
    var value = (linkText(link) + ' ' + link.href).toLowerCase();
    if (value.indexOf('collection') !== -1 || value.indexOf('collect') !== -1) return 'collection';
    if (value.indexOf('mail') !== -1 || value.indexOf('post') !== -1) return 'mail_in';
    return 'in_store';
  }

  function handleLinkClick(event) {
    var link = closestLink(event.target);
    if (!link) return;

    var href = link.getAttribute('href') || '';
    var absoluteHref = link.href || href;
    var lowered = absoluteHref.toLowerCase();
    var text = linkText(link);

    if (href.indexOf('tel:') === 0 || lowered.indexOf('tel:') === 0) {
      track('phone_click', {
        link_url: href,
        link_text: text
      });
      return;
    }

    if (lowered.indexOf('wa.me/') !== -1 || lowered.indexOf('whatsapp') !== -1) {
      track('whatsapp_click', {
        link_url: absoluteHref,
        link_text: text
      });
      return;
    }

    if (lowered.indexOf('/pages/make-a-booking') !== -1 || lowered.indexOf('/pages/book') !== -1) {
      track('booking_started', {
        booking_type: bookingType(link),
        link_url: absoluteHref,
        link_text: text
      });
    }
  }

  function isContactForm(form) {
    if (!form) return false;
    var action = String(form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/contact') !== -1) return true;
    return !!form.querySelector('[name^="contact["], input[name="form_type"][value="contact"]');
  }

  function handleFormSubmit(event) {
    if (!isContactForm(event.target)) return;
    track('contact_form_submit', {
      form_id: event.target.id || '',
      form_class: event.target.className || ''
    });
  }

  function faqQuestion(el) {
    if (!el) return '';
    return String(el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 160);
  }

  function handleFaqClick(event) {
    var summary = event.target.closest && event.target.closest('summary');
    if (summary && summary.closest('details')) {
      window.setTimeout(function () {
        if (!summary.closest('details').open) return;
        track('faq_interaction', {
          interaction_type: 'open',
          faq_question: faqQuestion(summary)
        });
      }, 0);
      return;
    }

    var toggle = event.target.closest && event.target.closest('[data-sr-faq-toggle], [data-sr-dh-faq-toggle], .nt_accordions_js .tab-heading');
    if (!toggle) return;

    var wasExpanded = toggle.getAttribute('aria-expanded') === 'true';
    window.setTimeout(function () {
      var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      if (wasExpanded && !isExpanded) return;
      track('faq_interaction', {
        interaction_type: 'open',
        faq_question: faqQuestion(toggle)
      });
    }, 0);
  }

  // Confirmed scheduling is distinct from clicking a booking link or attending a repair.
  // Calendly embed events: https://calendly.com/help/advanced-calendly-embed-for-developers
  var confirmedBookings = new Set();
  function handleCalendlyMessage(event) {
    if (event.origin !== 'https://calendly.com' || !event.data || event.data.event !== 'calendly.event_scheduled') return;
    var fromEmbed = Array.prototype.some.call(document.querySelectorAll('iframe[src]'), function (frame) {
      try { return new URL(frame.src).origin === event.origin && frame.contentWindow === event.source; }
      catch (error) { return false; }
    });
    if (!fromEmbed) return;
    var payload = event.data.payload || {};
    var bookingUri = payload.event && payload.event.uri;
    if (typeof bookingUri !== 'string' || !/^https:\/\/api\.calendly\.com\/scheduled_events\/[a-zA-Z0-9-]+$/.test(bookingUri)) return;
    if (confirmedBookings.has(bookingUri) || typeof window.srTrack !== 'function') return;
    confirmedBookings.add(bookingUri);
    // Do not forward the payload, invitee details, or booking identifier to analytics.
    track('booking_confirmed', { component: 'calendly_embed', booking_type: 'in_store' });
  }

  ready(function () {
    window.addEventListener('message', handleCalendlyMessage);
    document.addEventListener('click', handleLinkClick);
    document.addEventListener('click', handleFaqClick);
    document.addEventListener('submit', handleFormSubmit, true);
  });
})();
